// csvExport.js — client-side CSV download of the currently-displayed table rows.
// Shared by Market Watch, Positions, and Orders (mirrors the Journal / Tradable Universe
// download buttons). Exports the visible columns (respecting column customization), in
// display order, for whatever rows are currently shown (after filters + sort).
export function downloadRowsAsCSV(rows, columns, filename) {
  const csvVal = (val) => {
    const s = val == null ? '' : String(val);
    // Quote if the value contains a comma, quote, or newline; escape embedded quotes.
    return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
  };
  const cols = (columns || []).filter(c => c && c.key && c.label);
  const header = cols.map(c => csvVal(c.label)).join(',');
  const body = (rows || []).map(r => cols.map(c => csvVal(r[c.key])).join(',')).join('\n');
  const csv = header + '\n' + body;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  a.click();
  window.URL.revokeObjectURL(url);
}
